import { Link, useLocation } from 'react-router-dom'

export default function Header() {
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex flex-col">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">IBO</span>
              </div>
              <span className="font-bold text-xl text-gray-900">Question Maker</span>
            </Link>
            <div className="ml-10 mt-0.5">
              <span className="text-xs text-gray-500">
                made by <span className="font-medium text-gray-700">EIGENVECTOR 即未科技</span>
              </span>
            </div>
          </div>

          <nav className="flex items-center space-x-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${
                isActive('/')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              首页
            </Link>
            <Link
              to="/literature"
              className={`text-sm font-medium transition-colors ${
                isActive('/literature')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              文献列表
            </Link>
            <Link
              to="/questions"
              className={`text-sm font-medium transition-colors ${
                isActive('/questions')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              题目生成
            </Link>
            <Link
              to="/history"
              className={`text-sm font-medium transition-colors ${
                isActive('/history')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              历史记录
            </Link>
            <Link
              to="/api-config"
              className={`text-sm font-medium transition-colors ${
                isActive('/api-config')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              API配置
            </Link>
            <Link
              to="/analytics"
              className={`text-sm font-medium transition-colors ${
                isActive('/analytics')
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              后端监控
            </Link>
          </nav>
        </div>
      </div>
    </header>
  )
}
